import Image from 'next/image';

import { Box } from '@chakra-ui/react';

import { ContentContainer } from '~/components/container';
import { HeadingWithEmphasis } from '~/components/heading-with-emphasis';

export function PersonalizedDiscountHero() {
  const title = `**Save 25% or more** on Tech's top-rated
  courses for skill development`;

  return (
    <Box
      as='section'
      background='linear-gradient(83.05deg, #0C0E3A 14.44%, #282EAE 100%), #171A53;'
      color='white'
      display='flex'
      minHeight='120px'
      overflow='hidden'
      paddingY={{ base: '32px', md: '64px' }}
      position='relative'
    >
      <Box height='704px' left='50%' position='absolute' top='-25%' transform='translate(-50%, -50%)' width='2390px'>
        <Image
          alt=''
          quality={100}
          sizes='2390px'
          src='/images/backgrounds/blue-lines-wide.png'
          style={{
            objectFit: 'cover',
            objectPosition: 'center',
          }}
          fill
        />
      </Box>
      <ContentContainer
        alignItems='center'
        display='flex'
        flexDirection='column'
        justifyContent='center'
        position='relative'
      >
        <HeadingWithEmphasis
          text={title}
          emphasisProps={{
            color: 'accent.lime',
          }}
          headingProps={{
            as: 'h1',
            size: {
              base: 'marketing-lg',
              md: 'marketing-4xl',
            },
            color: 'white',
            textAlign: 'center',
            whiteSpace: {
              md: 'pre-wrap',
            },
            fontWeight: '500 !important',
          }}
        />
      </ContentContainer>
    </Box>
  );
}
